import React from 'react'
import { Grid as BaseGrid, styled } from '@mui/material'

export const Box = styled(({ alignItems, children, ...props }) => <div {...props}>{children}</div>)`
  align-items: ${props => props.alignItems};
  display: ${props => props.display};
  margin: ${props => props.margin};
  width: ${props => props.width};
`

export const Column = styled(({ flexGrow, margin, padding, width, ...props }) => <BaseGrid item {...props} />)`
  &.MuiGrid-root {
    flex-grow: ${props => props.flexGrow ?? ''};
    margin: ${props => props.margin || '0'};
    padding: ${props => props.padding || '0 5px'};
    width: ${props => props.width};
  }
`

export const Row = styled(({ margin, ...props }) => <BaseGrid container {...props} />)`
  &.MuiGrid-root {
    margin: ${props => props.margin || '0 -5px'};
    padding: 12px 0 0;
    width: 100%;
  }
`
